/**
 * Segmentos de rota das Configurações de Usuários — fonte única e tipada.
 * Alimenta o `configuracoes-usuario-routes.ts` (e qualquer `routerLink`/menu),
 * de modo que renomear um caminho seja alteração de um único lugar.
 */
export const CONFIGURACOES_USUARIO_ROUTES = {
    ROOT: 'usuarios',
    CADASTRO: 'cadastro',
    PERMISSOES: 'permissoes',
    MOTIVO_AFASTAMENTO: 'motivo-afastamento'
} as const;
